"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgInterchange = function SvgInterchange(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 145 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 23.711s18.274-3 58-3 58 4 58 4",
    stroke: "#EBECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.711c15.5-4.5 31.63-7 51.356-7 44.276 0 64.644 13 64.644 13",
    stroke: "#179FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.747 23.57-2.354 1.444s-.625.486-1.803.243-2.386-.51-2.386-.51-.26-.094-.438.137c-.179.232.115.37.115.37L2.7 26.57s.387.383.958.283c.57-.101 2.249-.442 2.249-.442s1.146-.244 2.508-1.094c1.362-.85 6.232-3.805 6.232-3.805s1.896-1.078 1.706-1.529c-.19-.45-1.283-.33-1.806-.165-.522.165-4.6 2.476-4.6 2.476l-4.47-1.532s-.577-.137-.288.2c.289.338 3.12 3.156 3.12 3.156m1.108 1.603 1.214 1.211s.352.28.424-.693c.07-.972.142-1.7.142-1.7m120.037-12.085-2.685-.644s-.785-.098-1.446-1.103c-.662-1.005-1.328-2.049-1.328-2.049s-.116-.25-.406-.212c-.29.037-.18.343-.18.343l.355 2.216s.002.545.477.877c.475.333 1.903 1.278 1.903 1.278s.983.638 2.547 1 7.098 1.716 7.098 1.716 2.102.579 2.286.126c.185-.454-.673-1.141-1.16-1.394-.486-.252-5.003-1.502-5.003-1.502l-2.078-4.243s-.311-.506-.345-.063c-.035.443-.025 4.438-.025 4.438m-.35 1.917.002 1.715s.052.447.79-.19a74.962 74.962 0 0 1 1.303-1.102",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.5 26.834a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgInterchange);
var _default = exports["default"] = Memo;